// ─────────────────────────────────────────────────────────
// Einstellungen → Zuschläge (%-Voreinstellung je Positionsart, plancraft-Stil)
// ─────────────────────────────────────────────────────────
// Eigenes Modul. Nutzt /api/surcharges (org-scoped, surcharges:read/write).
// Inline editierbar (kein Modal): 5 %-Felder + Speichern im Kopf.
// Sprache: alle sichtbaren Texte über t() — Keys in i18n/de.json + en.json.
import { icon, escapeHtml } from '../../utils/dom.js';
import { saveSurcharges } from '../../core/org.js';
import { t } from '../../i18n/index.js';

// Nur die Schlüssel — die Beschriftung kommt aus positionKinds.*, weil die
// Einheiten-Einstellung dieselben Positionsarten benutzt.
const FIELDS = ['lohn', 'material', 'geraete', 'fremdleistungen', 'sonstiges'];

function surcharges(s) {
  return s.surcharges || {};
}

// ── Kopf-Button „Speichern" ───────────────────────────────
export function surchargesHeadButton(ctx) {
  if (!ctx.can('surcharges:write')) return '';
  const saving = ctx.s.scSaving;
  return `<button class="cd-btn-primary" data-action="sc-save" ${saving ? 'disabled' : ''}>${escapeHtml(saving ? t('common.saving') : t('common.save'))}</button>`;
}

// ── Bereich ───────────────────────────────────────────────
export function renderSurchargesSection(ctx) {
  const { s, can } = ctx;
  if (!can('surcharges:read')) return `<div class="cd-set-empty">${escapeHtml(t('common.noPermission'))}</div>`;
  if (s.scLoading) return `<div class="cd-set-empty">${escapeHtml(t('common.loading'))}</div>`;

  const v = surcharges(s);
  const dis = s.scSaving || !can('surcharges:write') ? 'disabled' : '';
  const rows = FIELDS.map(
    (k) => `
      <div class="cd-sc-row">
        <span class="cd-sc-label">${escapeHtml(t('positionKinds.' + k))}</span>
        <div class="cd-sc-inwrap">
          <input class="cd-input cd-sc-in" id="sc-${k}" type="number" step="0.01" min="0" value="${Number(v[k]) || 0}" ${dis}>
          <span class="cd-sc-pct">%</span>
        </div>
      </div>`,
  ).join('');

  return `
    <div class="cd-emp">
      <div class="cd-emp-card">
        <div class="cd-emp-card-head">${icon('percent', 18)}<h3>${escapeHtml(t('settings.surcharges.title'))}</h3></div>
        <p class="cd-sc-lead">${escapeHtml(t('settings.surcharges.lead'))}</p>
        <div class="cd-sc-rows">${rows}</div>
      </div>
      <div class="cd-emp-info cd-sc-note">${icon('info', 18)}<span>${escapeHtml(t('settings.surcharges.note'))}</span></div>
    </div>`;
}

// ── Aktions-Handler ───────────────────────────────────────
export function handleSurchargeAction(a, el, ctx) {
  const { s, draw, reload } = ctx;
  if (a !== 'sc-save') return false;
  if (!ctx.can('surcharges:write')) return true;
  const read = (k) => Math.max(0, parseFloat(document.getElementById('sc-' + k)?.value) || 0);
  const payload = {};
  FIELDS.forEach((k) => { payload[k] = read(k); });
  s.scSaving = true; draw();
  saveSurcharges(payload)
    .then(() => { s.scSaving = false; if (reload) reload(); else draw(); })
    .catch((err) => { s.scSaving = false; s.error = err.message || t('common.saveFailed'); draw(); });
  return true;
}
